import * as actions from './productSearchActionsConstants';
import * as steps from './productSearchStepConstants';
import {MIN_PASSENGERS, MAX_PASSENGERS} from './productSearchPassengerConstants';
import moment from 'moment';

const initialState = {
  embedded: false,
  step: steps.PRODUCT_SEARCH_LOADING,
  origin_station_result: null,
  origin_search_label: '',
  origin_selections: [],
  destination_station_result: null,
  destination_search_label: '',
  destination_selections: [],
  passenger_quantity: 1,
  set_flight_alert: true,
  travel_date_selection: null,
  travel_time_selection: null,
  travel_time_selection_validated: null,
  travel_time_error: null,
  dates_with_flights: [],
  closed_weekdays: [],
  closed_dates: [],
  date_selection_tray: {
    loading: false,
    options: {
      continuous: {},
      schedule: {},
      charter: {},
      crowdsource: {},
      shared_charter: {}
    }
  },
  charter_search_form: {
    crowdsource: null,
    shared_charter: null,
    errors: {
      origin: null,
      destination: null
    }
  },
  origin_search_container: {
    back: null
  },
  destination_search_container: {
    back: null,
    hideOnCancel: false
  },
  selected_stations_validation: {
    loading: false,
    origins: null,
    destination: null
  },
  minimum_departure_date: null,
  suggested_stations: ""
};

export default function(state = initialState, action) {
  switch(action.type) {
    case actions.INIT_SERVER_STATE:
      return {
        ...state,
        ...action.processedServerState
      }
    case actions.PRODUCT_SEARCH_OPEN:
      return {
        ...state,
        step: steps.PRODUCT_SEARCH_FORM
      };
    case actions.CHARTER_TIME_SELECTION_OPEN:
      return {
        ...state,
        step: steps.CHARTER_TIME_SELECTION,
        charter_search_form: {
          ...initialState.charter_search_form,
          crowdsource: action.crowdsource,
          shared_charter: action.shared_charter
        }
      };
    case actions.ORIGIN_SEARCH_OPEN:
      return {
        ...state,
        step: steps.ORIGIN_SEARCH,
        origin_search_container: {
          back: action.back
        }
      };
    case actions.DESTINATION_SEARCH_OPEN:
      return {
        ...state,
        step: steps.DESTINATION_SEARCH,
        destination_search_container: {
          back: action.back
        }
      };
    case actions.DATE_SEARCH_OPEN:
      return {
        ...state,
        step: steps.DATE_SEARCH
      };
    case actions.ORIGIN_FILTER_OPEN:
      return {
        ...state,
        step: steps.ORIGIN_FILTER
      };
    case actions.DESTINATION_FILTER_OPEN:
      return {
        ...state,
        step: steps.DESTINATION_FILTER
      };
    case actions.ORIGIN_STATIONS_SELECTED:
      return {
        ...state,
        origin_station_result: action.station_result,
        origin_search_label: action.label,
        origin_selections: action.stations
      };
    case actions.ORIGIN_STATIONS_FILTERED:
      return {
        ...state,
        origin_search_label: action.label,
        origin_selections: action.stations
      };
    case actions.DESTINATION_STATIONS_SELECTED:
      return {
        ...state,
        destination_station_result: action.station_result,
        destination_search_label: action.label,
        destination_selections: action.stations
      };
    case actions.DESTINATION_STATIONS_FILTERED:
      return {
        ...state,
        destination_search_label: action.label,
        destination_selections: action.stations
      };
    case actions.SWAP_STATION_VALUES:
      return {
        ...state,
        origin_station_result: state.destination_station_result,
        origin_search_label: state.destination_search_label,
        origin_selections: state.destination_selections,
        destination_station_result: state.origin_station_result,
        destination_search_label: state.origin_search_label,
        destination_selections: state.origin_selections,
        charter_search_form: {
          ...state.charter_search_form,
          errors: {}
        }
      };
    case actions.PASSENGER_QUANTITY_SELECTED:
      if(action.quantity >= MIN_PASSENGERS && action.quantity <= MAX_PASSENGERS) {
        return {
          ...state,
          passenger_quantity: action.quantity
        };
      }
      return state;
    case actions.FLIGHT_ALERT_SET:
      return {
        ...state,
        set_flight_alert: action.boolean
      };
    case actions.TRAVEL_DATE_SELECTED:
      return {
        ...state,
        travel_date_selection: action.date
      };
    case actions.TRAVEL_TIME_RESET:
      return {
        ...state,
        travel_time_error: null,
        travel_time_selection: null,
        travel_time_selection_validated: null
      }
    case actions.TRAVEL_TIME_SELECTED:
      return {
        ...state,
        travel_time_selection: action.time,
        travel_time_selection_validated: false
      };
    case actions.TRAVEL_TIME_VALIDATED:
      return {
        ...state,
        travel_time_error: action.error,
        travel_time_selection_validated: true
      };
    case actions.CALENDAR_PARAMETERS_SUCCESS:
      return {
        ...state,
        dates_with_flights: action.dates_with_flights,
        closed_weekdays: action.closed_weekdays,
        closed_dates: action.closed_dates
      }
    case actions.PRICE_DATE_LOADING:
      return {
        ...state,
        date_selection_tray: {
          loading: true,
          options: initialState.date_selection_tray.options,
        }
      }
    case actions.PRICE_DATE_SUCCESS:
      return {
        ...state,
        date_selection_tray: {
          loading: false,
          options: action.options
        }
      }
    case actions.STATIONS_VALIDATION_LOADING:
      return {
        ...state,
        selected_stations_validation: {
          loading: true,
          origins: null,
          destinations: null
        }
      }
    case actions.STATIONS_VALIDATED:
      return {
        ...state,
        selected_stations_validation: {
          loading: false,
          origins: action.origins,
          destinations: action.destinations
        }
      }
    default:
      return state;
  }
}

export const buildSearchParams = function(state, flight_type) {
  let {productSearch} = state;

  let {
    origin_selections: origins,
    origin_search_label: origin_label,
    origin_station_result,
    destination_selections: destinations,
    destination_search_label: destination_label,
    destination_station_result,
    passenger_quantity: passengers,
    travel_date_selection: selected_date,
    travel_time_selection: selected_time,
    step: step,
    suggested_stations: suggested_stations
  } = productSearch;

  let origin_codes = _.map(origins, (o) => {
    return o.code;
  });

  let destination_codes = _.map(destinations, (d) => {
    return d.code;
  });

  let params = {
    flight_type: flight_type,
    origin: origin_codes.join(),
    origin_search_label: origin_label,
    origin_type: origin_station_result.result_type,
    origin_id: origin_station_result.result_id,
    destination: destination_codes.join(),
    destination_search_label: destination_label,
    destination_type: destination_station_result.result_type,
    destination_id: destination_station_result.result_id,
    passengers: passengers,
    depart_date: moment(selected_date).format('YYYY-MM-DD'),
    suggested_stations: suggested_stations
  }

  if (flight_type === 'charter' || flight_type === 'crowdsource' || flight_type === 'shared_charter') {
    params.depart_time = selected_time;
  }

  if (step === steps.ADD_FLIGHT) {
    params.add_flight = true;
  }

  return params;
}
